module.exports = __webpack_public_path__ + "img/ruihong_swiper_06.407e4288.jpg";